import initMultiInputPin from '../modules/multi-input-pin';

const initialize = () => {
    initMultiInputPin('.eu-panel button[type="submit"]', true);
};

export default initialize;
